import EditWidgetPropertyModal from "../../EditWidgetPropertyModal";
import useMenu from "../menu/useMenu";

export default function useValueTextMenu({ property, object }) {
  const items = useMenu();

  return [
    items.genMenuEditItem({
      title: "Edit text",
      handleAction: () => {
        EditWidgetPropertyModal({
          widgetId: object.id,
          propId: property.id,
          propKey: property.key,
        })
          .then()
          .catch(() => {});
      },
    }),
    items.genMenuShowHistory({
      disabled: true,
    }),
  ];
}
